import React, {Component} from 'react';
import PropTypes from 'prop-types';

import clientLogger from '../../utils/client-logger';
import logger from '../../utils/logger';

class ErrorBoundary extends Component {

    static propTypes = {
        errorTitle: PropTypes.string,
        errorMessage: PropTypes.string
    }

    constructor() {
        super();
        this.state = {hasError: false};
    }

    componentWillReceiveProps = () => {
        /* We want to clear this state everytime ErrorBoundary re-renders */
        this.setState({hasError: false});
    };

    componentDidCatch(error, info) {
        this.setState({hasError: true});
        clientLogger.captureException(error, {extra: info});
        logger.log({message: `Error boundary page rendered. error: ${error} info: ${info}`});
    }

    render() {
        const {hasError} = this.state;

        const errorStyle = {
            paddingTop: '40px',
            paddingBottom: '40px'
        };

        if (hasError) {
            return (
              <div className="row text-center" style={errorStyle}>
                  <svg className="inline-svg svg-xl svg-warning ">
                      <use xlinkHref="#svg-alert"/>
                  </svg>
                  <h3>{this.props.errorTitle}</h3>
                  <p>{this.props.errorMessage}</p>
              </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/universal/components/error-boundary/error-boundary.js